import { useContext, useState, useSyncExternalStore } from "react"
import { BenefitEditorContext } from "./benefitEditorContext"
import type { BenefitToolSelection } from "./benefitEditorSlice"

const noSubscribe = () => () => {}

/** Preserve the editor's surrounding tool through unmount; standalone sections remain local. */
export function useBenefitToolView() {
  const controller = useContext(BenefitEditorContext)
  const [local, setLocal] = useState<BenefitToolSelection | null>(null)
  const stored = useSyncExternalStore(controller?.store.subscribe ?? noSubscribe,
    () => controller?.toolView() ?? null, () => null)
  return {
    view: controller ? stored : local,
    select(view: BenefitToolSelection) { if (controller) controller.selectToolView(view); else setLocal(view) },
    close(section: BenefitToolSelection["section"]) {
      if (controller) controller.closeToolView(section)
      else setLocal(previous => previous?.section === section ? null : previous)
    },
  }
}
